<template>
  <div class="toast-container position-fixed bottom-0 end-0 p-3">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast show"
      :class="`text-bg-${toast.type}`"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-header">
        <strong class="me-auto">{{ toast.title }}</strong>
        <small>{{ toast.time }}</small>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
          @click="removeToast(toast.id)"
        ></button>
      </div>
      <div class="toast-body">
        {{ toast.message }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useToast } from '../composables/useToast';

const { toasts, removeToast } = useToast();

// Optional: Bootstrap's JS for toasts if needed for more complex interactions
// import { Toast } from 'bootstrap';
// onMounted(() => {
//   document.querySelectorAll('.toast').forEach(toastEl => {
//     new Toast(toastEl);
//   });
// });
</script>

<style scoped>
.toast-container {
  z-index: 1080; /* Higher than Bootstrap modals (1050) */
}
</style>
